import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  ImplicitFlowConfig,
  implicitFlowConfig,
  ImplicitFlowService,
} from '@cigna/shared/angular/auth/oidc-util/implicit';
import {
  AuthDataAccessModule,
  AuthConfig,
  authConfig,
} from '@cigna/shared/angular/auth-data-access';

import { CignaForBrokersAuthenticationService } from './+state/authentication.service';
import { GatewayConfig } from '@cigna/cigna-for-brokers/shared/gateways';
import {
  OktaFlowConfig,
  oktaFlowConfig,
  OktaFlowService,
} from '@cigna/shared/angular/auth/okta-util';

@NgModule({
  imports: [CommonModule, AuthDataAccessModule],
})
export class CignaForBrokersAuthDataAccessModule {
  static withConfig(
    config: GatewayConfig,
  ): ModuleWithProviders<CignaForBrokersAuthDataAccessModule> {
    const oktaConfig: OktaFlowConfig = {
      issuer: '',
      redirectUri: '',
      postLogoutRedirectUri: '',
      clientId: '',
      tokenExpirationInMin: 0,
    };

    return {
      ngModule: CignaForBrokersAuthDataAccessModule,
      providers: [
        implicitFlowConfig({
          authorizeUri: config.authorizeUri,
          clientId: config.clientId,
          metadataUri: config.metadataUri,
          redirectUri: config.redirectUri,
        }),
        authConfig({
          authenticator: ImplicitFlowService,
          errorHandler: CignaForBrokersAuthenticationService,
          secureUris: [
            'secure/home/',
            config.cfbApiUrl,
            config.getSpotlight,
            config.gsgApiUrl,
          ],
          publicUris: [],
          noRefreshUris: [],
          loadBehavior: 'onDemand',
        }),
        oktaFlowConfig(oktaConfig),
      ],
    };
  }

  static getWithConfig(
    isOktaEnable: boolean,
    config: CignaForBrokersOktaAuthConfig | GatewayConfig,
  ): ModuleWithProviders<CignaForBrokersAuthDataAccessModule> {
    if (isOktaEnable) {
      return this.withOktaConfig(config as CignaForBrokersOktaAuthConfig);
    }

    return this.withConfig(config as GatewayConfig);
  }

  static withOktaConfig(
    config: CignaForBrokersOktaAuthConfig,
  ): ModuleWithProviders<CignaForBrokersAuthDataAccessModule> {
    return {
      ngModule: CignaForBrokersAuthDataAccessModule,
      providers: [
        oktaFlowConfig(config),
        implicitFlowConfig({
          authorizeUri: '',
          clientId: '',
          metadataUri: '',
          redirectUri: '',
        }),
        authConfig({
          loadBehavior: 'onDemand',
          authenticator: OktaFlowService,
          errorHandler: CignaForBrokersAuthenticationService,
          secureUris: config.secureUris,
          publicUris: config.publicUris,
          noRefreshUris: config.noRefreshUris,
        }),
      ],
    };
  }
}

export type CignaForBrokersAuthConfig = Pick<
  AuthConfig,
  'secureUris' | 'publicUris' | 'noRefreshUris'
> &
  ImplicitFlowConfig;

export type CignaForBrokersOktaAuthConfig = Pick<
  AuthConfig,
  'secureUris' | 'publicUris' | 'noRefreshUris'
> &
  OktaFlowConfig &
  ImplicitFlowConfig;
